import React, { useState, useEffect, useRef } from 'react';
import { Color, ConstCss } from '../../const/Const';
import PageTitle from '../PageTitle/PageTitle';
import PageFilter from '../PageFilter/PageFilter';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import { TextField } from '@fluentui/react';
import GridFilter from '../GridFilter/GridFilter';
import { searchData } from '../../SharedFunc/FilterAndSearch.js';
import { ReactComponent as Divider } from '../../svg/verticalDividerGray.svg';
import { ReactComponent as IconFilter } from '../../svg/filterIcon.svg';
import { ReactComponent as SearchIcon } from '../../svg/searchBlack.svg';
import { ReactComponent as ExitIcon } from '../../svg/exit.svg';

const PageHeader = (props) => {

    const [searchValue, setSearchValue] = useState();
    const [showFilter, setShowFilter] = useState(false);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState(props.columns ? props.columns : []);
    const searchFieldRef = useRef();

    const onSearch = (p_value) => {

        setSearchValue(p_value.target.value);

        let filteredData = [...data];
        if (p_value?.target?.value && data?.length > 0) {
            filteredData = searchData(p_value?.target?.value, data);
        }

        if (props.setSearchParams) {
            props.setSearchParams({
                search: p_value?.target?.value,
                filter: props.searchParams.get('filter')
            });
        }

        if (props.onSearch) {
            props.onSearch(filteredData);
        }

    };

    useEffect(() => {
        let tData = [];
        if (props.data) {
            tData = props.data;
        }
        if (props?.showfilter == true) {
            setShowFilter(true);
        }
        setData(tData);

    }, [props.data]);

    useEffect(() => {
        if (showFilter) {
            searchFieldRef?.current?.focus();
        }
    }, [showFilter]);

    useEffect(() => {
        if (props.searchParams) {
            let tSearchParam = props.searchParams.get('search');
            if (props.searchParams.get('filter') || tSearchParam) {
                setShowFilter(true);
                if (tSearchParam && tSearchParam?.toString() != "null") {
                    if (props.setSearchValue) {
                        props.setSearchValue(tSearchParam);
                    }
                }
            }
        }
    }, []);

    const onGridFilterChange = (p_gridfiltervalue) => {

        if (props.setSearchParams) {
            try {
                props.setSearchParams({
                    search: props.searchParams.get('search'),
                    filter: JSON.stringify(p_gridfiltervalue)
                });
            } catch (e) {
                props.setSearchParams({
                    search: props.searchParams.get('search'),
                    filter: JSON.stringify([])
                });
            }
        }

        if (props.onGridFilterChange) {
            props.onGridFilterChange(p_gridfiltervalue);
        }
    }

    const onExit = () => {
        let filteredData = [...data];
        if (props.onSearch) {
            props.onSearch(filteredData);
        }
        if (props.onGridFilterChange) {
            if (props.setSearchParams) {
                props.setSearchParams({
                    search: '',
                    filter: JSON.stringify([])
                });
            }
            props.onGridFilterChange([]);
        }
        setSearchValue([]);
    }

    const onChangeFilter = () => {
        setShowFilter(r => !r);
        setSearchValue([]);
        props.onGridFilterChange([]);
    }

    return (
        <div>
            <div style={{
                height: 50,
                width: '100%',
                backgroundColor: Color.grayBackground,
                display: 'flex',
                justifyContent: 'space-between',
                paddingLeft: 16,
                paddingRight: 16
            }}>
                <div style={{ ...ConstCss.flexCenter }}>

                    {!props.showLeftFilter && (
                        <div style={{ marginRight: 16 }}>
                            <PageTitle>{props.title} {(props.loading != true && props.dataCount) ? ("(" + props.dataCount + ")") : null}</PageTitle>
                        </div>
                    )}
                    {props.showLeftFilter && (
                        <div style={{ marginRight: 16 }}>
                            <PageFilter onChange={props.changeFilter} value={props.filterValue} data={props.filterData} dataCount={props.dataCount} />
                        </div>
                    )}
                    <div style={{ height: 28 }}>
                        <Divider />
                    </div>
                    <div style={{ marginLeft: 16, marginBottom: '5px' }}>
                        {props.buttonTitle && (<ButtonIcon text={props.buttonTitle} iconName='Add' onClick={props.onButtonClick} />)}
                    </div>
                    {props.addButton && (
                        <div style={{ marginLeft: 16 }}>
                            {props.addButton}
                        </div>
                    )}
                </div>
                <div style={{ ...ConstCss.flexCenter }}>
                    {props.addRightButton ? (props.addRightButton) : null}
                    {props.data ? (
                        <div onClick={onChangeFilter} style={{ marginLeft: 8 }} >
                            <IconFilter />
                        </div>
                    ) : null}
                </div>
            </div>
            {showFilter && props.showDetailSearch ? (
                <div>
                    {props.children}
                </div>
            ) : null}
            {showFilter ? (
                <div style={{
                    height: 50,
                    width: '100%',
                    backgroundColor: Color.grayHeaderBack,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingLeft: 16,
                    paddingRight: 16
                }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SearchIcon />
                        <TextField componentRef={searchFieldRef} onChange={onSearch} style={{ backgroundColor: Color.grayHeaderBack, minWidth: 300 }} borderless placeholder={props.lang == "en" ? "Search..." : "Хайх..."} value={searchValue} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <GridFilter data={props.gridFilter} onGridFilterChange={onGridFilterChange} />
                        <div onClick={onExit} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <ExitIcon />
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}
export default PageHeader;